import { render, staticRenderFns } from "./FAQBoardEdit.vue?vue&type=template&id=084d4185&scoped=true"
import script from "./FAQBoardEdit.vue?vue&type=script&lang=js"
export * from "./FAQBoardEdit.vue?vue&type=script&lang=js"
import style0 from "./FAQBoardEdit.vue?vue&type=style&index=0&id=084d4185&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084d4185",
  null
  
)

export default component.exports